export default {
  getNewsList: (state: any) => state.newsList,
  getNewsPagination: (state: any) => state.pagination,
  getNewsLoading: (state: any) => state.loading,
  // Public news getters
  getPublicNews: (state: any) => state.publicNews,
  getPublicNewsPagination: (state: any) => state.publicNewsPagination,
  getPublicNewsLoading: (state: any) => state.publicNewsLoading,
}

